import React from 'react'
import { RichText } from '../RichText'
import { IProps } from './index'

export function EditorialInfo({ info }: IProps) {
  return (
    <div className="editorial-info">
      <div className="editorial-info__attributes">
        <RichText document={info} />
      </div>
    </div>
  )
}
